const state = {
  product: [
    {
      type: "product",
      product: "",
      price: "",
      discount: "",
    },
  ],
};

const getters = {
  getProduct(state) {
    return state.product;
  },
};

const mutations = {
  SET_PRODUCT(state, payload) {
    state.product.push(payload);
  },
  SET_REMOVE_PRODUCT(state, payload) {
    state.product.splice(payload, 1);
  },
};

const actions = {
  setProduct({ commit }, payload) {
    commit("SET_PRODUCT", payload);
  },
  setRemoveProduct({ commit }, payload) {
    commit("SET_REMOVE_PRODUCT", payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
